<script>
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import useForm from '../../../../Composables/useForm.js'
import useProductField from '../../Composables/useProductField'
import uniqueId from 'lodash/uniqueId'
import { EQUIPMENT_CONDITION_NEW } from '../../Constants/EquipmentCondition'

export default {
  components: { FormCreator, FieldCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    disabled: { type: Boolean, default: false },
    mainId: { type: Number, required: true },
    platformParamId: { type: Number, required: false },
    platformId: { type: Number, required: false },
    equipment: { type: Object, required: false, default: null },
    addEquipment: { type: Boolean, default: false },
    context: { type: String },
  },
  emits: ['equipment-sent'],
  data: () => ({
    loading: false,
    url: '',
    sending: false,
    loadForm: false,
    params: {},
    loadField: false,
    supplierArticle: false,
    articleChoices: [],
    formData: null,
    productType: null,
    condition: EQUIPMENT_CONDITION_NEW,
  }),

  computed: {
    modalId() {
      let id = this.equipment?.id ?? uniqueId('new-equipment-')
      return 'modal-equipment-' + id
    },
    isVehicule() {
      return this.productType?.vehicule === true
    },
    isDisabled() {
      return this.equipment === null && this.disabled
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    globalBuild({ def, object }) {
      this.setFormDef(def)
      this.setFormData(object)

      if (object.unitAmountPurchaseSent === null && object.unitAmountPurchase) {
        this.$refs.myform.object.unitAmountPurchaseSent = object.unitAmountPurchase
      }

      this.productType = object.productType
      this.condition = object.condition
    },
    setDatas(json) {
      this.$emit('equipment-sent', json)
      this.closeModal()
    },
    isSending(bool) {
      this.sending = bool
    },
    getArticleChoice(choices) {
      this.articleChoices = choices
    },
    getArticle(val, choices) {
      if (val) {
        this.articleChoices.map((choice) => {
          if (choice.id == val) {
            this.$refs.myform.object.brand = choice.equipmentBrand
            this.$refs.myform.object.model = choice.equipmentModel
            this.$refs.myform.object.unitAmount = choice.equipmentUnitAmount
            this.$refs.myform.object.unitAmountPurchaseSent = choice.equipmentUnitAmountPurchase
            this.$refs.myform.object.supplierArticle = null
            if (choice.suppliers.length == 1) {
              this.$refs.myform.def.supplierArticle.options.choices.push(choice.suppliers[0])
              this.$refs.myform.object.supplierArticle = choice.suppliers[0].id
            }
            this.supplierArticle = true
          }
        })
      } else {
        this.supplierArticle = false
      }
    },
    openModal() {
      this.$refs.dialog.open()
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.$refs.dialog.close(false)
    },
    showForm() {
      if (this.equipment?.id) {
        this.params = { mainId: this.mainId, id: this.equipment.id }
      } else {
        this.params = { mainId: this.mainId }
      }
      this.loadForm = true
    },
    setEquipmentType(val, choices) {
      const selectedEquipmentType = choices.find((choice) => choice.id === Number(val))
      if (!selectedEquipmentType) {
        return
      }

      this.$refs.myform.object.equipmentType = selectedEquipmentType
      this.$refs.myform.object.productType = null
      if (selectedEquipmentType.productTypes.length === 1) {
        this.$refs.myform.object.productType = selectedEquipmentType.productTypes[0]
      }
    },
    onFirstRegistrationAtChange(date) {
      if (date === null || date.isValid === false) {
        return
      }
      this.$refs.myform.object.year = date?.toFormat('yyyy') ?? null

      if (!!date) {
        this.disableField('year')
      } else {
        this.enableField('year')
      }
    },
  },
  setup(props) {
    const form = useForm()
    const { product } = useProductField({ form, product: props.equipment?.product ?? null })

    return {
      setFormDef: form.setFormDef,
      setFormData: form.setFormData,
      isFieldDisplayed: form.isFieldDisplayed,
      enableField: form.enableField,
      disableField: form.disableField,
      product,
    }
  },
  mounted() {
    this.productType = this.equipment?.productType ?? null
    this.condition = this.equipment?.condition ?? EQUIPMENT_CONDITION_NEW
  },
  watch: {
    product(value) {
      if (value) {
        this.productType = value.productType
        this.condition = value.condition
      }
    },
  },
}
</script>
<template>
  <div class="equipment-form d-flex">
    <a
      :class="isDisabled ? 'cursor-disabled' : 'cursor-pointer'"
      role="button"
      @[!isDisabled&&`click`]="showForm"
      :e2e-button="equipment === null ? 'equipmentAdd' : 'equipmentUpdate'"
    >
      <i :class="['fa', equipment === null ? 'fa-plus-circle' : 'fa-edit']"></i>
      {{ equipment === null ? $t('equipment.add') : '' }}
    </a>

    <Teleport to="body">
      <ModalDialog
        :id="modalId"
        id-modal-page="equipment-list"
        class-modal-dialog="modal-xl"
        ref="dialog"
        @icon-close="closeModal"
        e2e-modal="equipment-list"
      >
        <div class="d-flex justify-content-center align-items-center flex-fill" v-if="loading">
          <div class="spinner-border" style="width: 5rem; height: 5rem" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else></div>

        <template v-if="loadField">
          <FieldCreator
            v-if="isFieldDisplayed('product')"
            :form-data="formData"
            v-model="product"
            name="product"
            form-ref="formsimulation"
            domain="equipment"
            label-property="label"
            value-property="id"
            group-property="equipmentType.name"
            label-left
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="article"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            select-change="supplierArticle"
            select-change-by-name="suppliers"
            :platform-param-id="platformParamId"
            :platform-id="platformId"
            @get-autocomplete-result="getArticleChoice"
            @get-select-change="getArticle"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            v-if="supplierArticle"
            name="supplierArticle"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            v-if="!supplierArticle"
            :form-data="formData"
            name="supplier"
            form-ref="myform"
            domain="equipment"
            label-left
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            v-if="isTheme('eurolocatique')"
            name="salesman"
            form-ref="myform"
            domain="equipment"
            label-left
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="equipmentType"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            select-change="productType"
            select-change-by-name="productTypes"
            @get-select-change="setEquipmentType"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            v-model="productType"
            :form-data="formData"
            name="productType"
            value-property="id"
            form-ref="myform"
            domain="equipment"
            label-left
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="brand"
            form-ref="myform"
            domain="equipment"
            label-left
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="model"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="serialNumber"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="refId"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            v-model="condition"
            :form-data="formData"
            name="condition"
            type-value="string"
            not-remove
            form-ref="myform"
            domain="equipment"
            label-left
            dynamic-label
            :disabled="disabled"
          />

          <template v-if="!isTheme('eurolocatique') && isVehicule">
            <FieldCreator
              :form-data="formData"
              name="plate"
              form-ref="myform"
              domain="equipment"
              label-left
              dynamic-label
              :disabled="disabled"
            />

            <FieldCreator
              :form-data="formData"
              name="firstRegistrationAt"
              form-ref="myform"
              domain="equipment"
              label-left
              dynamic-label
              @get-date-change="onFirstRegistrationAtChange"
              :disabled="disabled"
            />
          </template>

          <template v-if="condition === 'OCCASION'">
            <FieldCreator
              :form-data="formData"
              name="year"
              form-ref="myform"
              domain="equipment"
              label-left
              dynamic-label
              :disabled="disabled"
            />

            <FieldCreator
              :form-data="formData"
              v-if="isVehicule"
              name="usage"
              form-ref="myform"
              domain="equipment"
              label-left
              dynamic-label
              :disabled="disabled"
            />

            <FieldCreator
              :form-data="formData"
              name="hours"
              form-ref="myform"
              domain="equipment"
              label-left
              dynamic-label
              :disabled="disabled"
            />
          </template>

          <FieldCreator
            :form-data="formData"
            name="unitAmount"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="unitAmountPurchaseSent"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="unitAmountSoft"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="unitAmountPrestation"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="quantity"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            name="amount"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />

          <FieldCreator
            :form-data="formData"
            v-if="hasRole('ROLE_STATUT_EQUIPMENT_SHOW') && context !== 'simulation'"
            name="status"
            form-ref="myform"
            domain="equipment"
            :label-left="true"
            dynamic-label
            :disabled="disabled"
          />
        </template>

        <div class="mt-2 mb-4">
          <FormCreator
            v-if="loadForm"
            ref="myform"
            endpoint="equipments"
            :id="equipment?.id"
            :params="params"
            :in-modal="true"
            class-to-add="btn-lg"
            :submit-disabled="disabled"
            @global-build="globalBuild"
            @modal-build="openModal"
            @form-build="setBuild"
            @form-return="setDatas"
            @is-sending="isSending"
            @update-data="updateData"
            name="equipmentValidateUpdate"
          >
            <div v-if="sending" class="text-center">
              <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else>
              {{ $t('button.validate') }}
            </div>
          </FormCreator>
          <button type="button" class="btn btn-lg btn-secondary ml-4" @click="closeModal" e2e-button="close">
            {{ $t('button.close') }}
          </button>
        </div>
      </ModalDialog>
    </Teleport>
  </div>
</template>
